
import { Injectable } from '@angular/core';
import * as jsPDF from 'jspdf'
// import * as htmlPDF  from 'html-pdf';

/*
  Generated class for the PrintPdfProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PrintPdfProvider {

  constructor() {


    
  }

  makePdf(title, subtitle, cpgNumber, element) { 
    console.log('will make here');

    let doc = new jsPDF();
    doc.setFontSize(17);

    doc.setFillColor(127, 127, 127);
    doc.rect(100, 20, 10, 10, 'F');

    doc.setTextColor(255, 0, 0);
    doc.text(100,25, 'USD.00');
    doc.save('a4.pdf');
    //doc.autoPrint();

  }


}



// WEBPACK FOOTER //
// ./src/providers/print-pdf/print-pdf.ts